// extracted by mini-css-extract-plugin
module.exports = {"greenid-div":"_3X1XA"};